import React from 'react';
import {
  Stat,
  Text,
  StatLabel,
  StatNumber,
  StatHelpText,
  StatArrow,
  StatGroup,
  Card,
  CardBody,
  Container,
  useColorModeValue,
  ChakraProvider,
  Box,
} from '@chakra-ui/react';
import Graph from '../Graph';

import SidebarWithHeader from '../SidebarWithHeader';
const Statistics = () => {
  return (
    <div
      style={{
        justifyContent: 'center',
        flex: 1,

        height: '70vh',
        alignItems: 'center',
        alignContent: 'center',
      }}
    >
      <Text
        style={{
          textAlign: 'center',
          padding: 30,
        }}
      >
        Comming soon...
      </Text>
    </div>
  );
};

export default Statistics;
